var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHammer3Black(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    width: "0px",
    height: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 17.609192, -5.682769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71 94.715 L 171 94.715 L 171 379.715 L 71 379.715 L 71 94.715 Z",
    style: {
      strokeWidth: 30,
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246 101.802 L 246 259.715 L 325.837 259.715 L 325.837 217.604 L 441 217.604 L 441 99.715 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(0, 0, 0)",
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(0, 0, 0)"
    },
    d: "M 461.978 128.411 L 461.978 249.188 L 435.055 249.188 L 435.055 308.951 L 507.565 236.441 L 507.565 128.49 L 461.978 128.411 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 121.715,
    width: 26.602,
    height: 51.225,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 183.017,
    width: 26.602,
    height: 51.225,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 196 245.49 L 222.602 245.49 L 222.602 278.804 L 310.795 278.804 L 310.795 296.715 L 196 296.715 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310.795 308.951 L 310.795 360.176 L 196 360.176 L 196 308.951 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.319,
    y: 38.101,
    width: 91.681,
    height: 45.995,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 365 570.348 L 273.319 570.348 L 273.319 370.574 L 365 370.574 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 234.242 L 416 234.242 L 416 360.176 L 360 360.176 L 360 360.177 L 324.292 360.177 L 324.292 277.282 L 349 277.282 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer3Black);
export default __webpack_public_path__ + "static/media/Hammer3-Black.559d0336d61db4a3b1ab3eec597df03a.svg";
export { ForwardRef as ReactComponent };